import { isUndefined } from 'lodash';
import { PositionDto, PrivateQuoteDto, PrivateQuoteSnapDto } from 'src/dtos';
import { Position, Quote } from 'src/models';

const enrichNonTradablePosition = (model: Position, privateQuote: PrivateQuoteDto): Position => {
  let result: Position = {
    ...model,
    isTradable: false,
    value: privateQuote.currentPrice,
    totalValue: model.quantity * privateQuote.currentPrice,
  };

  if (result.purchasePrice === 0) {
    result.purchasePrice = privateQuote.purchasePrice;
  }

  return result;
};

const addNonTradableOrderPositionQuoteIfFound = (model: Position, snap: PrivateQuoteSnapDto[]): Position => {
  const privateQuoteSnap = snap?.find(aPrivateQuoteSnap => aPrivateQuoteSnap.symbol === model.symbol);

  if (!privateQuoteSnap) {
    return model;
  }
  let result = { ...model };

  if (!isNaN(privateQuoteSnap.lastPrice) && privateQuoteSnap.lastPrice !== 0) {
    result.value = privateQuoteSnap.lastPrice;
    result.totalValue = result.quantity * privateQuoteSnap.lastPrice;
  }

  return result;
};

const makeNonTradablePositionIfFound = (
  model: Position,
  privateQuotes: PrivateQuoteDto[],
  snap: PrivateQuoteSnapDto[],
): Position => {
  const privateQuote = privateQuotes.find(aPrivateQuote => aPrivateQuote.symbol === model.symbol);

  if (!privateQuote) {
    return model;
  }
  let result = enrichNonTradablePosition(model, privateQuote);
  result = addNonTradableOrderPositionQuoteIfFound(result, snap);

  return result;
};

export const mapPositionDtoToModel = (
  dto: PositionDto,
  snap: Quote[],
  privateQuotes: PrivateQuoteDto[],
  privateSnap: PrivateQuoteSnapDto[],
): Position => {
  let result: Position = {
    id: dto.OrderId.toString(),
    symbol: dto.Symbol,
    name: dto.Description,
    quantity: dto.OpenQuantity,
    purchasePrice: dto.OpenPrice,
    isTradable: true,
    totalCost: dto.CostBasis,
  };
  const positionSnap = snap.find(aSnap => aSnap.symbol === dto.Symbol);

  if (positionSnap && !isUndefined(positionSnap.last) && !isUndefined(positionSnap.change)) {
    result.value = positionSnap.last;
    result.totalValue = positionSnap.last * result.quantity;
    result.change = positionSnap.change / 100;
  }

  if (positionSnap?.description) {
    result.name = positionSnap.description;
  }

  result = makeNonTradablePositionIfFound(result, privateQuotes, privateSnap);

  return result;
};

export const mapPositionListDtoToModel = (
  dtos: PositionDto[],
  snap: Quote[],
  privateQuotes: PrivateQuoteDto[],
  privateSnap: PrivateQuoteSnapDto[] = [],
): Position[] => dtos.map(dto => mapPositionDtoToModel(dto, snap, privateQuotes, privateSnap));
